import * as CreateRequest from './components/Exchange/CreateRequest/CreateRequest.css';
import * as Disclaimer from './components/Exchange/Disclaimer/Disclaimer.css';
import * as Payment from './components/Exchange/Payment/Payment.css';
import * as Dialog from './components/Exchange/Dialog/Dialog.css';
import * as ExchangeCheckoutStatus from './components/Exchange/ExchangeCheckoutStatus/ExchangeCheckoutStatus.css';
import * as Datepicker from './components/Exchange/SearchFlights/Calendar/Datepicker/Datepicker.css';
import * as AirportServices from './components/Exchange/AirportServices/AirportServices.css';

export default {
	CreateRequest,
	Disclaimer,
	Payment,
	Dialog,
	ExchangeCheckoutStatus,
	Datepicker,
	AirportServices
};
